import InputField from 'components/forms/InputField'
import React from 'react'
import { Field } from 'redux-form'
import { validateHouseNumber } from '../util/validateHouseNumber'
import { useTranslation } from 'react-i18next'

export function HouseNumberInput() {

    const { t } = useTranslation()
    
    return <div className='form-group row'>
            <label className='col-md-6 control-label required'>{t('profile.houseNumber')}</label>
        <div className='col-md-6'>
            <Field
                type='text'
                component={InputField}
                name='houseNumber'
                validate={validateHouseNumber}
            />
        </div>
    </div>
}